"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _restrictInput = require("../normalizers/restrictInput");
var _regex = _interopRequireWildcard(require("../regex"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formValidationOrderIdRequired = 'Please enter valid order number';
var ORDER_ID = {
  component: _Input["default"],
  name: 'orderId',
  label: 'Order number',
  id: 'orderId',
  type: 'text',
  autoComplete: 'off',
  hint: 'Enter your order number (8 or 9 digits)',
  required: true,
  regex: (0, _regex["default"])(_regex.numbersPattern),
  validationMessageKeys: {
    required: formValidationOrderIdRequired,
    maxLength: formValidationOrderIdRequired,
    maxLengthInt: formValidationOrderIdRequired,
    regex: formValidationOrderIdRequired
  },
  normalize: _restrictInput.numbersOnly
};
var _default = exports["default"] = ORDER_ID;